import formatPrice from 'src/utils/currency-code-to-symbol';
import { cn } from 'src/lib/utils';

type Props = {
  total: number;
  currency: string;
  period: string;
  className?: string;
};

export default function BillingTotal({ total, currency, period, className }: Props) {
  return (
    <div className={cn('flex items-center justify-between gap-3 border-t border-b border-border py-6', className)}>
      <div className="text-xl font-semibold text-foreground">Total:</div>
      <div className="flex flex-col gap-2">
        <strong className="text-xl text-foreground">{formatPrice(currency, total, true)}</strong>
        <div className="text-sm text-muted-foreground">
          Billed/
          <span className="capitalize">{period}</span>
        </div>
      </div>
    </div>
  );
}
